import React, { useState, useEffect } from "react"
import Button from "@material-ui/core/Button"
import { Register } from "../../redux/apiCalls"
import "./register.css"
import { useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import { renderErrorMsg } from "../../services/errorsForm"
import { Snackbar, IconButton } from "@mui/material"
import { Close } from "@material-ui/icons"

const Login = () => {
  const [registerForm, setRegisterForm] = useState()
  const dispatch = useDispatch()
  const [formErrorMsg, setFormErrorMsg] = useState()

  const handleChangeForm = (e) => {
    setRegisterForm({
      ...registerForm,
      [e.target.name]: e.target.value,
    })
  }
  const onRegister = () => {
    Register(dispatch, registerForm, setFormErrorMsg, handleClick)
  }
  // snackbar when register
  const [open, setOpen] = useState(false)
  const handleClick = () => {
    setOpen(true)
  }
  const handleClose = (reason) => {
    if (reason === "clickaway") {
      return
    }
    setOpen(false)
  }
  const closeSnackbarButton = (
    <IconButton
      size='small'
      aria-label='close'
      color='inherit'
      onClick={handleClose}>
      <Close fontSize='small' color='white' />
    </IconButton>
  )
  return (
    <div className='register__background'>
      <form className='register__form'>
        <h1 className='register__title'>Register</h1>
        <input
          placeholder='First Name'
          onChange={handleChangeForm}
          type='text'
          name='first_name'
          className='register__input'
        />
        {renderErrorMsg(formErrorMsg, "first_name")}
        <input
          placeholder='Last Name'
          onChange={handleChangeForm}
          type='text'
          name='last_name'
          className='register__input'
        />
        {renderErrorMsg(formErrorMsg, "last_name")}
        <input
          placeholder='Email'
          onChange={handleChangeForm}
          type='text'
          name='email'
          className='register__input'
        />
        {renderErrorMsg(formErrorMsg, "email")}
        <input
          placeholder='Phone Number'
          onChange={handleChangeForm}
          type='text'
          name='phone'
          className='register__input'
        />
        {renderErrorMsg(formErrorMsg, "phone")}
        <input
          placeholder='Address'
          onChange={handleChangeForm}
          type='text'
          name='address'
          className='register__input'
        />
        {renderErrorMsg(formErrorMsg, "address")}
        <input
          placeholder='Password'
          onChange={handleChangeForm}
          type='password'
          name='password'
          className='register__input'
        />
        {renderErrorMsg(formErrorMsg, "password")}
        <input
          placeholder='Confirm Password'
          onChange={handleChangeForm}
          type='password'
          name='password_confirm'
          className='register__input'
        />
        {renderErrorMsg(formErrorMsg, "password_confirm")}
        <Button
          variant='contained'
          onClick={onRegister}
          className='register__btn'>
          Register
        </Button>
        <p className='link__login'>
          Already have an account? <Link to='/login'>Login</Link>
        </p>
      </form>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        message='Account Created'
        action={closeSnackbarButton}
      />
    </div>
  )
}

export default Login
